define('views/modules/calendar/animated-session/exercise/edit/exercise-edit-block',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/calendar/session/animation',
    // views
    'views/modules/calendar/animated-session/exercise/weight/week-edit/weight-edit-content',
    'views/modules/calendar/animated-session/exercise/cardio/cardio-content',
    'views/modules/calendar/animated-session/animation/animation-detail-modal',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/edit/exercise-edit-block.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MAnimation,
    // views
    VWeightEditContent,
    VCardioContent,
    VAnimationDetailModal,
    // templates
    TExerciseEditBlock
) {

    var VExerciseEditBlock = Backbone.Epoxy.View.extend({
        template: TExerciseEditBlock,

        events: {
            "click .ucol-photo": "onAnimationPlayClick"
        },

        regions: {
            content: ".exercise-content",
            addSetButton: ".add-set-button",
            removeSetButton: ".remove-set-button",
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                view = this.view = {};

            _.extend(this, {
                item: opt.item,
            });
        },

        render: function() {
            var model = this.model;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend(model.toJSON(), {
                animation: model.getAnimation(),
                showTCNotes: !this.model.get("hideTCNotes")
            }))));

            this.generateZones()
                .applyBindings();

            var view = this.view,
                zone = this.zone;

            this.resetContentView();

            return this;
        },

        addContentView: function() {
            var model = this.model,
                content = this.view.content;

            if (model.isWeight()) {
                content = this.view.content = new VWeightEditContent({
                    model: model,
                    item: this.item,
                    summary: true
                });
            } else if (model.isCardio()) {
                content = this.view.content = new VCardioContent({
                    model: model,
                    item: this.item
                });
            }

            this.childViews.push(content);
            this.assign(content, this.zone.$content);
        },

        resetContentView: function() {
            this.zone.$content.empty();
            this.removeChildViews({ defer: true });
            this.addContentView();
        },

        onAnimationPlayClick: function() {
            var animation = this.model.getAnimation(),
                view = this.view.detail;
            if (!animation) return;
            if (!view) {
                view = this.view.detail = new VAnimationDetailModal();
            }

            view.setTCNotesDisplay(!this.model.get("hideTCNotes"), this.model.get("notes"));
            view.setModel(animation).render();
        },

    });

    return VExerciseEditBlock;

});

